import { render } from "./ModalOtp.vue?vue&type=template&id=b4d98904&scoped=true"
import script from "./ModalOtp.vue?vue&type=script&lang=js"
export * from "./ModalOtp.vue?vue&type=script&lang=js"

import "./ModalOtp.vue?vue&type=style&index=0&id=b4d98904&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4d98904"]])

export default __exports__